import {Component, Input} from '@angular/core';
import {BaseComponent} from 'app/components/base/base.component';
import {Event, EventId} from 'app/models/base/event';
import {UserCalendar} from 'app/models/lookups/user-calendar';
import {UserCalendarService} from 'app/services/lookups/user-calendar.service';
import {NgForm} from '@angular/forms';
import {Status} from '../../../../models/web-method-result';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'bms-new-calendar-item',
  templateUrl: './new-calendar-item.component.html',
  styleUrls: ['./new-calendar-item.component.scss']
})
export class NewCalendarItemComponent extends BaseComponent {

  @Input() datum: Date;
  newCalendarItem: UserCalendar = new UserCalendar(null);
  // activeItem : boolean = true;
  @Input() activeUserId: string;
  datumPrikaz: String;
  @Input() calendarItems: UserCalendar[];
  allDay: UserCalendar[];
  edit: boolean;

  private newTaskMsg: string;
  private editTaskMsg: string;
  private deleteConfigMsg: string

  constructor(private userCalendarService: UserCalendarService,
              private translate: TranslateService) {
    super();
  }

  protected initTranslationParams() {
    this.translate.get('newCalendarItem.deleteConfirmMessage').subscribe(t => this.deleteConfigMsg = t);
    this.translate.get('newCalendarItem.newTask').subscribe(t => this.newTaskMsg = t);
    this.translate.get('newCalendarItem.editTask').subscribe(t => this.editTaskMsg = t);
  }

  onShown() {
    this.allDay = this.allDayEvents();
    // console.log(this.allDay);
    this.newCalendarItem.dateOfEvent = this.datum;
    this.newCalendarItem.appUserId = this.activeUserId;
    this.datumPrikaz = this.datum.toLocaleString('en-US', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'});
    this.edit = false;
    this.cancelEdit();

    super.onShown();
    super.enableEnterAsTab(true);
  }

  onClose() {
    this.fireEvent(new Event(EventId.DIALOG_CANCEL, null));
  }

  onSubmit(f: NgForm) {
    this.newCalendarItem.description = $('#description').val();
    $('#activity').prop('checked') ? this.newCalendarItem.activity = 0 : this.newCalendarItem.activity = 1;
    this.newCalendarItem.dateOfEvent.setHours(0, 0, 0, 0);

    if (this.edit) {
      this.newCalendarItem.id = parseInt($('#id').val(), 10);
      this.userCalendarService.updateUserCalendarItem(this.newCalendarItem).subscribe(
        data => {
          // console.log(data);
          const idx = this.allDay.findIndex(obj => obj.id === this.newCalendarItem.id);
          if (idx !== -1) {
            this.allDay[idx] = this.newCalendarItem;
          }
        }
      );
    } else {
      this.userCalendarService.saveUserCalendarItem(this.newCalendarItem);
      this.allDay.push(this.newCalendarItem);
    }

    super.ngOnInit();
    this.onClose();
  }

  deleteCalendarItem(id: number) {
    if (confirm(this.deleteConfigMsg)) {  // 'Da li ste sigurni da zelite da obrisete izabrani zadatak?'
      this.userCalendarService.deleteUserCalendarItem(id).subscribe(
        res => {
          if (res.status.toString() === Status[Status.SUCCESS]) {
            const idx = this.allDay.findIndex(obj => obj.id === id);
            if (idx !== -1) {
              this.allDay.splice(idx, 1);
            }
          } else {
            this.setError(res);
          }
        },
        error => this.setError(error));
    }
  }

  compareDates(izBaze: string | number | Date) {
    const datum0 = new Date(izBaze);
    return datum0.getDate() === this.datum.getDate() && datum0.getMonth() === this.datum.getMonth() &&
      datum0.getFullYear() === this.datum.getFullYear();
  }

  allDayEvents() {
    const events = [];
    for (const item of this.calendarItems) {
      if (this.compareDates(item.dateOfEvent)) {
        events.push(item);
      }
    }
    return events;
  }

  editCalendarItem(item) {
    $('#id').val(item.id);
    $('#description').val(item.description).css('background-color', 'lemonchiffon');
    $('#activity').prop('checked', !item.activity);
    $('#naslov').html(this.editTaskMsg);
    this.edit = true;
  }

  cancelEdit() {
    $('#description').val('').css('background-color', 'white');
    $('#activity').prop('checked', false);
    $('#naslov').html(this.newTaskMsg);
    this.edit = false;
  }
}
